<template>
  <!-- VeeValidate v4 Field API: https://vee-validate.logaretm.com/v4/api/field/ -->
  <Field
    v-slot="{ errors, validate }"
    v-bind="{
      ...FieldProps
    }"
    :rules="rules ? veeValidateRules : undefined"
    :name="name"
    :label="getLabel"
    :as="tag"
    :model-value="modelValue"
  >
    <slot
      v-bind="{
        // Pass Vuetify-friendly attrs
        attrs: {
          // Vuetify input custom rules (functions)
          rules: rules ? vuetifyInputRules : undefined,
          // Vuetify error messages prop
          errorMessages: errors,

          // validateOn: 'blur',
        },
        // Expose validate for manual triggers
        validateInput: validate
      }"
    />
  </Field>
</template>

<script setup>
import { Field } from 'vee-validate'

// import AvailableRules from '@/plugins/validations'
// ? component must extend VInput 1st

const props = defineProps({
  rules: {
    type: [String, Array, Function],
    default: undefined
  },
  modelValue: {
    type: [String, Number, Boolean, Array, Object],
    default: undefined
  },
  tag: {
    type: String,
    default: 'div'
  },
  // https://vee-validate.logaretm.com/v4/api/field/#:~:text=defaults%20to%20input-,name,-string
  name: {
    type: String,
    default: ''
  }
})

const attrs = useAttrs()

const FieldProps = {
  // validateOnMount: false,
  // validateOnInput: false,
  // validateOnChange: false,
  // validateOnBlur: false,
  // validateOnModelUpdate: false,
}

const veeValidateRules = computed(() => {
  let rules = props.rules
  if (!rules) return undefined
  if (typeof rules === 'string') rules = [rules]
  if (!Array.isArray(rules)) return undefined
  const targetRules = []
  rules.forEach(rule => {
    if (typeof rule === 'string') {
      // check if rule is available,
      // if not, console.error and keep going
      const tmpRule = rule.split(':')[0]
      // if (!(tmpRule in AvailableRules)) console.error(reportNotAvailableRules(rule))
      targetRules.push(rule)
    }
  })
  return targetRules.join('|')
})

const vuetifyInputRules = computed(() => {
  let rules = props.rules
  if (!rules) return undefined
  if (typeof rules === 'function') rules = [rules]
  if (!Array.isArray(rules)) return undefined
  const targetRules = []
  rules.forEach(rule => {
    if (typeof rule === 'function') targetRules.push(rule)
  })
  return targetRules
})

const getLabel = computed(() => {
  if (attrs.props && attrs.props.label) return attrs.props.label
  return undefined
})
</script>

<style>

</style>
